import { LoaderCircle } from "lucide-react";
import { cn } from "@/shared/lib/cn";

export function Spinner({ className, label }: { className?: string; label: string }) {
  return (
    <span role="status" className={cn("inline-flex items-center gap-2 text-muted", className)}>
      <LoaderCircle className="size-5 animate-spin" aria-hidden />
      <span className="sr-only">{label}</span>
    </span>
  );
}
